import { SelectOption } from '@globaleris/ui.library'
import { Contrato } from '../../api'
import { EnumTipoNotificacion } from '../../api/oData/enums/enumTipoNotificacion'
import { enumEnumToValueNumber, enumKeyToValue } from '../../helpers'
import { ContactInfoModel } from '../clients/clients.model'
import {
  filterApplicableActionsConfiguration,
  getGlobalActionsConfiguration
} from './contactsInfo.service'
import { generateIconsFromConfiguration } from '../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../model'

export const contactsInfoItemsMapper = (items: ContactInfoModel[]): ContactInfoModel[] => {
  return items && items.map(contactInfoItemMapper)
}

export const contactInfoItemMapper = (item: ContactInfoModel): ContactInfoModel => {
  return (
    item && {
      ...item,
      notificationType: enumEnumToValueNumber(EnumTipoNotificacion, item.notificationType),
      canDelete: item.principal ? false : true,
      actionsConfiguration: getGlobalActionsConfiguration(),
      phoneNumber: item.phoneNumber && item.phoneNumber !== '' ? item.phoneNumber : undefined
    }
  )
}

export const contactInfoRowMapper = (item: ContactInfoModel): ContactInfoModel => {
  return (
    item && {
      ...item,
      phoneNumber: item?.phoneNumber?.replaceAll(' ', '')
    }
  )
}

export const contractsMapperToDropDown = (items: Contrato[]): SelectOption[] => {
  return items && items.map(contractMapperToDropDown)
}

export const contractMapperToDropDown = (item: Contrato): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.codContrato || ''
    }
  )
}

export const completeDataTableActions = (item: ContactInfoModel): ContactInfoModel => {
  return {
    ...item,
    actions:
      item.actionsConfiguration &&
      item.actionsConfiguration.length > 0 &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfiguration(item, item.actionsConfiguration),
        new Map<ActionIcons, Function>([])
      )
  }
}
